import React, { useEffect, useRef, useState } from 'react';
import * as S from './styles';

const Tooltip = (props = {}) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [leftPos, setLeftPos] = useState();
    const [windowWidth, setWindowWidth] = useState();

    const tooltipRef = useRef(null);

    const handleCloseTooltip = () => {
        if (showTooltip) {
            setShowTooltip(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleCloseTooltip);

        if (typeof window !== 'undefined') {
            setWindowWidth(window.innerWidth);
            if (tooltipRef && tooltipRef.current && tooltipRef.current.offsetParent.offsetLeft + 317 >= windowWidth) {
                setLeftPos(-300);
            }
        }

        return () => {
            document.removeEventListener('click', handleCloseTooltip);
        };
    }, [showTooltip]); // eslint-disable-line

    return (
        <S.TooltipWrapper>
            <S.TooltipLink onClick={() => setShowTooltip(true)}>ⓘ</S.TooltipLink>
            {showTooltip && (
                <S.TooltipPopupWrapper leftPos={leftPos} ref={tooltipRef}>
                    <S.TooltipPopup>
                        {props.children}
                    </S.TooltipPopup>

                </S.TooltipPopupWrapper>
            )}
        </S.TooltipWrapper>
    );
};

export default Tooltip;
